import en from './en.json';
import ru from './ru.json';
import la from './la.json';
import uz from './uz.json';

export const locales = [
    {
        code: 'ru',
        name: 'Русский',
        file: 'ru.json',
        icon: 'ru-flag',
    },
    {
        code: 'en',
        name: 'English',
        file: 'en.json',
        icon: 'en-flag',
    },
    {
        code: 'la',
        name: 'O`zbekcha',
        file: 'la.json',
        icon: 'uz-flag',
    },
    {
        code: 'uz',
        icon: 'uz-flag',
        name: 'Ўзбекча',
        file: 'uz.json',
    },
];

export const languages = {
    en,
    ru,
    la,
    uz,
};
